import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel with the project's API key
mixpanel.init("f6220cd0b6569de0051982d2b2da4967");

// Define a set of actions that can be performed using Mixpanel
let actions = {
  // Function to identify a user
  identify: (id: string) => {
    mixpanel.identify(id);
  },
  // Function to create an alias for a user
  alias: (id: string) => {
    mixpanel.alias(id);
  },
  // Function to track an event
  track: (name: string, props?: any) => {
    mixpanel.track(name, props);
  },
  // Function to reset Mixpanel (clear user data)
  reset: () => {
      mixpanel.reset();
  },
  // Functions related to user profiles
  people: {
    // Function to set user profile properties
    set: (props: any) => {
      mixpanel.people.set(props);
    },
  },
};

// Export the actions for use in the application
export const MixpanelWrapper = actions;